import styled from "@emotion/styled";
import React from "react";
import { CloseIcon } from "./SVGIcons";
// import iconImg from "../images/icon.png";
import iconImg from "../images/icon.jpeg";
import useAppStore from "../appStore";
const ChatHeader = () => {
  const setChatOpen = useAppStore((state) => state.setChatOpen);
  return (
    <StyledChatHeader>
      {/* <BackButton onClick={() => setChatOpen(false)}>
        <CloseIcon />
      </BackButton> */}
      <IconWrapper>
        <img src={iconImg} alt="" />
        <GreenCircle />
      </IconWrapper>
      <InfoWrapper>
        <h3>Mo</h3>
        <p>Welcome to Mozaic Senior Life!</p>
      </InfoWrapper>
    </StyledChatHeader>
  );
};

const StyledChatHeader = styled.div`
  display: flex;
  gap: 14px;
  padding: 14px;
  width: 400px;
  height: 60px;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 10px 10px 0 0;
`;

const BackButton = styled.button`
  height: 32px;
  width: 32px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.lightBlack};
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    svg {
      scale: 1.05;
    }
  }
  svg {
    scale: 1;
    width: 8px;
    height: 12px;
    transition: scale 0.2s ease-in-out;
  }
`;

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  outline: 1px solid ${({ theme }) => theme.colors.transparentWhite};
  position: relative;
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
`;

const GreenCircle = styled.div`
  width: 9px;
  height: 9px;
  background: ${({ theme }) => theme.colors.green};
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: 0;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  h3 {
    color: ${({ theme }) => theme.colors.white};
    font-size: 14px;
  }
  p {
    color: ${({ theme }) => theme.colors.transparentWhite};
    font-size: 12px;
    line-height: 18px;
  }
`;

export default ChatHeader;
